import { useEffect } from "react";

interface CustomerServiceChatProps {
  email?: string;
}

export default function CustomerServiceChat({ email }: CustomerServiceChatProps) {
  useEffect(() => {
    const script = document.createElement("script");
    //Chat e Analytics
    // script.src = `//js.hs-scripts.com/${process.env.REACT_APP_CUSTOMER_SERVICE_ID}.js`;
    //Apenas Analytics
    script.src = `//js.hs-analytics.net/analytics/${new Date().getFullYear()}/${
      process.env.REACT_APP_CUSTOMER_SERVICE_ID
    }.js`;
    script.async = true;
    script.defer = true;
    script.id = "hs-script-loader";
    document.body.appendChild(script);

    if (email) {
      script.onload = () => {
        const _hsq = ((window as any)._hsq = (window as any)._hsq || []);
        _hsq.push([
          "identify",
          {
            email,
          },
        ]);
        _hsq.push(["trackPageView"]);
      };
    }
  }, [email]);

  return null;
}
